import classNames from "classnames";
import React from "react";
import styles from "./GeneralInputWrapper.module.scss";
const GeneralInputWrapper = ({
  children,
  isError
}) => {
  return /*#__PURE__*/React.createElement("div", {
    id: "general-text",
    className: classNames("general-input-wrapper-view", {
      [styles.generalInputWrapper]: true,
      [styles.error]: isError
    })
  }, children);
};
export default GeneralInputWrapper;
//# sourceMappingURL=GeneralInputWrapper.js.map